:host {
    display: block;
}

.promotion-badge {
    position: absolute;
    margin-top: 1%;
    margin-left: 1%;
    background: red;
    color: white;
    font-weight: 700;
    padding: 0.25em 0.25rem;
    border-radius: 0.25rem;
}

.pictogram {
    position: relative;
    float: right;
    margin-top: 1%;
    margin-right: 1%;
    padding: 0.25em;
}

.new-pictogram{
    margin-right: 8px;
}
